/**
 * @generated SignedSource<<cd02f9ca9a7eb194e3b6bb8539006f87>>
 * @relayHash 128040f48675f30ee14ee92aa2775b5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f94fe827c3d242661e2b6fbc8c0edc3d8271936b83d2f4930aed015102c1989

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionIssuesSortField = "ASSIGNEE" | "CREATED" | "KEY" | "PRIORITY" | "STATUS" | "TYPE" | "%future added value";
export type JiraVersionIssuesStatusCategories = "DONE" | "IN_PROGRESS" | "TODO" | "%future added value";
export type JiraVersionWarningCategories = "FAILING_BUILD" | "OPEN_PULL_REQUEST" | "OPEN_REVIEW" | "UNREVIEWED_CODE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraVersionIssuesFiltersInput = {
  assigneeAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  epicIds?: ReadonlyArray<string> | null | undefined;
  searchStr?: string | null | undefined;
  statusCategories?: ReadonlyArray<JiraVersionIssuesStatusCategories> | null | undefined;
  warningCategories?: ReadonlyArray<JiraVersionWarningCategories> | null | undefined;
};
export type JiraVersionIssuesSortInput = {
  order?: SortDirection | null | undefined;
  sortByField?: JiraVersionIssuesSortField | null | undefined;
};
export type verionDetailsIssueListQuery$variables = {
  after?: string | null | undefined;
  filters?: JiraVersionIssuesFiltersInput | null | undefined;
  first?: number | null | undefined;
  id: string;
  isDevopsFeatureDisabledInFedRamp: boolean;
  sortBy?: JiraVersionIssuesSortInput | null | undefined;
};
export type verionDetailsIssueListQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion">;
  } | null | undefined;
};
export type verionDetailsIssueListQuery = {
  response: verionDetailsIssueListQuery$data;
  variables: verionDetailsIssueListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v8 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = [
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "filter",
    "value": "ALL"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v15 = {
  "kind": "ScalarField",
  "name": "count"
},
v16 = {
  "kind": "ScalarField",
  "name": "state"
},
v17 = [
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "verionDetailsIssueListQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "verionDetailsIssueListQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "JiraVersionWarningConfig",
                "kind": "LinkedField",
                "name": "warningConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "openPullRequest"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "openReview"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "unreviewedCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "failingBuild"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canViewDevTools"
              },
              {
                "kind": "ScalarField",
                "name": "versionIssueTableHiddenColumns"
              },
              {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
              },
              {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "projectId"
                  },
                  (v11/*: any*/)
                ]
              },
              (v12/*: any*/),
              {
                "alias": "issuesForList",
                "args": (v13/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  },
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v10/*: any*/),
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                  "priority",
                                  "summary",
                                  "assignee",
                                  "status",
                                  "issuetype"
                                ]
                              }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "statusCategoryId"
                                                  },
                                                  (v10/*: any*/)
                                                ]
                                              },
                                              (v10/*: any*/),
                                              (v12/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "description"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusField"
                                      },
                                      (v10/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "picture"
                                              },
                                              (v12/*: any*/),
                                              (v10/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "text"
                                          }
                                        ],
                                        "type": "JiraSingleLineTextField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              (v12/*: any*/),
                                              {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "xsmall"
                                                  }
                                                ]
                                              },
                                              (v10/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraPriority",
                                            "kind": "LinkedField",
                                            "name": "priority",
                                            "plural": false,
                                            "selections": [
                                              (v12/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                              },
                                              (v10/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraPriorityField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "issueId"
                          },
                          (v9/*: any*/),
                          {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "concreteType": "DevOpsSummarisedEntities",
                                "kind": "LinkedField",
                                "name": "devOpsSummarisedEntities",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "DevOpsSummarisedDeployments",
                                    "kind": "LinkedField",
                                    "name": "summarisedDeployments",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "concreteType": "DevOpsEnvironment",
                                        "kind": "LinkedField",
                                        "name": "deploymentEnvironment",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "category"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "deploymentState"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "DevOpsSummarisedBuilds",
                                    "kind": "LinkedField",
                                    "name": "summarisedBuilds",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "concreteType": "DevOpsSummarisedBuildState",
                                        "kind": "LinkedField",
                                        "name": "buildStates",
                                        "plural": true,
                                        "selections": [
                                          (v16/*: any*/),
                                          (v15/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                    "kind": "LinkedField",
                                    "name": "summarisedFeatureFlags",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "mostRelevantDisplayName"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "mostRelevantEnabled"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "mostRelevantRolloutPercentage"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraIssueDevSummaryResult",
                                "kind": "LinkedField",
                                "name": "devSummaryCache",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueDevSummary",
                                    "kind": "LinkedField",
                                    "name": "devSummary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "pullrequest",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v16/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "branch",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueBranchDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": (v17/*: any*/)
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "review",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueReviewDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v16/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "lastUpdated"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "stateCount"
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                            "kind": "LinkedField",
                                            "name": "summaryByProvider",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "providerId"
                                              },
                                              (v12/*: any*/),
                                              (v15/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "commit",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueCommitDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": (v17/*: any*/)
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "build",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueBuildDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "failedBuildCount"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "successfulBuildCount"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "unknownBuildCount"
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "deploymentEnvironments",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                "kind": "LinkedField",
                                                "name": "topEnvironments",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "issuesForList",
                "args": (v13/*: any*/),
                "filters": [
                  "filter",
                  "sortBy",
                  "filters"
                ],
                "handle": "connection",
                "key": "ListVersion_issuesForList",
                "kind": "LinkedHandle",
                "name": "issues"
              },
              {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "DevOpsProviders",
                        "kind": "LinkedField",
                        "name": "providers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsFeatureFlagProvider",
                            "kind": "LinkedField",
                            "name": "featureFlagProviders",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "createFeatureFlagTemplateUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "connectFeatureFlagTemplateUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraVersion"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6f94fe827c3d242661e2b6fbc8c0edc3d8271936b83d2f4930aed015102c1989",
    "metadata": {},
    "name": "verionDetailsIssueListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1a52a23b324242e6dd47774f54758481";

export default node;
